import { Box, Typography } from '@mui/material';
import { ReactNode } from 'react';
import { FormattedMessage } from 'react-intl';

export function InfoRow({
    labelId,
    color = 'text.primary',
    children,
}: {
    labelId: string;
    color?: string;
    children: ReactNode;
}) {
    return (
        <Box sx={{ minWidth: 0 }}>
            <Typography variant="caption" color="text.secondary" noWrap>
                <FormattedMessage id={labelId} />
            </Typography>
            <Typography
                variant="caption"
                color={color}
                sx={{ display: 'block', fontWeight: 500, lineHeight: 1.4 }}
            >
                {children}
            </Typography>
        </Box>
    );
}
